import { render, staticRenderFns } from "./AutomationKeywordsTable.vue?vue&type=template&id=792cfd4c&"
import script from "./AutomationKeywordsTable.vue?vue&type=script&lang=js&"
export * from "./AutomationKeywordsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports